export const get = (obj, unsafeOperation, valueIfFail) => {
  try {
    return unsafeOperation(obj);
  } catch (error) {
    return valueIfFail;
  }
};
